import { styled } from 'linaria/react';
import { breakpoints } from 'media';

export const RulesContent = styled.div`
	display: grid;
	grid-template-columns: 1fr 271px;
	gap: var(--space-400);
	width: 100%;
	margin-bottom: 40px;

	${breakpoints.to.largeDesktop} {
		grid-template-columns: 1fr 209px;
	}

	${breakpoints.only.mobile} {
		grid-auto-rows: max-content;
		grid-template-columns: 1fr;
	}
`;
